/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import store from '../store/store'
import router from './router'
import config from '../assets/config.json'
import { Message } from 'view-design'

// let ReqApi = process.env.NODE_ENV === 'development' ? config.api.reqApi : config.testApi.reqApi;
let ReqApi = config.api.reqApi;
// axios 配置
axios.defaults.baseURL = ReqApi;
// http request 拦截器
axios.interceptors.request.use(
  config => {  
    // if (store.state.refresh && store.state.login && store.getters.getTokenTime) { 
    //   if (new Date().getTime() > store.getters.getTokenTime) { 
    //     store.commit('setRefreshStatus', false, { root: true });
    //     store.commit('setTokenTime', '', { root: true });
    //     store.dispatch('refreshToken');
    //   }
    // }  
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  res => {
    return res;
  }, err => {
    if (err.response) {
      switch (err.response.status) {
        case 401: 
          Message.error({
            content: '授权过期，请重新登录', onClose: function () {
              store.commit('setLogin', false, { root: true });
              store.commit('setUser', null, { root: true });
              store.commit('setAuth', null, { root: true });
              store.commit('setToken', null, { root: true });
              localStorage.clear();
              location.reload();
              // router.replace({ path: '/home' });
            }
          });
          break;
        case 400:
          // Message.error('400:请求接口有误！');
          break;
        case 404:
          router.replace({ path: '/404' });
          break;
        case 500:
          router.replace({ path: '/500' });
          break;
      }
    }
    return Promise.reject(err);
  }
);

// 封装请求
const get = (url, params) => { // 单独封装get请求
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(function (response) {
        resolve(response.data);
      }).catch(err => {
        reject(err)
      })
  })
};
const post = (url, params) => { // 单独封装post请求
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(function (response) {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
  })
};

Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$http = axios
